import {useState, useEffect} from 'react';

const gradientColors = ['#7f7fd5', '#86a8e7', '#91eae4'];

export function useAnimatedGradient(isActive: boolean) {
	const [gradientStep, setGradientStep] = useState(0);
	const [animatedBorder, setAnimatedBorder] = useState<React.CSSProperties>({});

	useEffect(() => {
		if (isActive) {
			const interval = setInterval(() => {
				setGradientStep((prevStep) => (prevStep + 1) % 360);
			}, 1);

			return () => {
				clearInterval(interval);
			};
		}
	}, [isActive]);

	useEffect(() => {
		if (isActive) {
			setAnimatedBorder({
				backgroundImage: `linear-gradient(${gradientStep}deg, ${gradientColors[0]}, ${gradientColors[1]}, ${gradientColors[2]})`,
			});
		} else {
			setAnimatedBorder({});
		}
	}, [gradientStep, isActive]);

	return {
		animatedBorder,
		gradientStep,
	};
}
